<template>
  <div id="app">
    <!-- 左边悬浮广告 -->
    <ul id="leftAdv"
        class="left_ad"
        v-if="isShow">
      <li v-for="(item,index) in leftAdList"
          :key="index">
        <a :href="item.linkValue"
           target="_blank">
          <img :src="common.showPic(item.adPic)"
               :onerror="common.defaultImg()"
               @click="clickAd(item.id)">
        </a>
      </li>
    </ul>
    <router-view />
    <!-- 右边悬浮广告 -->
    <ul id="rightAdv"
        class="right_ad"
        v-if="isShow">
      <li v-for="(item,index) in rightAdList"
          :key="index">
        <a :href="item.linkValue"
           target="_blank">
          <img :src="common.showPic(item.adPic)"
               :onerror="common.defaultImg()"
               @click="clickAd(item.id)">
        </a>
      </li>
    </ul>
    <!-- 返回顶部按钮 -->
    <BackTop :height="500"
             :bottom="100">
<!--      <div class="back-top">
        <i class="ivu-icon ivu-icon-ios-arrow-up"></i>
      </div>-->
      <div class="tips-warpper" id="tips" style="right: 54.5px; bottom: 0px;">
        <ul>
          <a class="tips-top" @click="goPage('/index')" target="_blank"><img src="@/assets/images/tips-top.gif" style="width: 160px"></a>
<!--          <li class="firsthand-nav" style="display: none;"><a href="javascript:;" class="firsthand-tip">一手<br>货源</a></li>-->
          <li class="origin-sources-nav"><a @click="goPage('/user/userIndex')"  class="origin-tip">个人<br>中心</a></li>
          <li  class="item-kefu"  @mouseenter="enter" @mouseleave="leave">
            <a href="javascript:;" target="_blank" class="tip-line-one">客服</a>
            <div class="kf-popbox" v-show="seen" @mouseenter="enter" @mouseleave="leave">
              <p>采购批发鞋，就上鞋库网</p>
              <p><img src="@/assets/images/weach.jpg" style=" width: auto;height: auto;max-width: 100%;max-height: 100%;"></p>
              <p>平台客服，点击咨询</p>
              <p><a href="https://wpa.qq.com/msgrd?v=3&amp;uin=848906161&amp;site=qq&amp;menu=yes" target="_blank" rel="noopener"><img src="@/assets/images/i-qq-newstip.png" style="width: 120px;height: 27px"></a></p>
              <p class="timersked">服务时间：09:00-18:00</p></div>
            <a href="https://wpa.qq.com/msgrd?v=3&amp;uin=848906161&amp;site=qq&amp;menu=yes" target="_blank" ><img src="@/assets/images/i-kefu-tip.png" alt="" class="tip-hover-icon"></a>
          </li>
          <li  class="origin-sources-nav">
            <a class="firsthand-tip" @click="goPage('/user/menuLayout/browseRecord')">历史<br>足迹</a>
<!--            <div class="app-tip-main" style="display: none; opacity: 0; right: 98px;">
              <div class="qrCodeItem"><div class="left"><a href="/specialnew/app" target="_blank"><img src="/images/go2-app-qr.png?0.1"></a></div><div class="right"><div class="title">GO2货源</div><div class="desc">一手精选货源</div><div class="icons"><div class="iconItem"><div class="icon"><img src="/images/icon/i-ios.png" alt=""></div><div class="iconTitle">IPhone</div></div><div class="iconItem"><div class="icon"><img src="/images/icon/i-android.png" alt=""></div><div class="iconTitle">Android</div></div></div></div></div>
              <div class="qrCodeItem"><div class="left"><a href="javascript:;"><img src="/images/app-weixin.png?0.1"></a></div><div class="right"><div class="title">微信公众号</div><div class="desc">关注【GO2购途网】公众号，获取更多资讯</div></div></div>
            </div>-->
<!--            <img src="/images/icon/i-qr-code-tip.png" alt="" class="tip-hover-icon">-->
          </li>
          <li id="JS_go_top" class="top-item"><i class="icon" title="回到顶部"></i></li>
        </ul>
      </div>
    </BackTop>
  </div>
</template>
<script src="https://cdn.staticfile.net/translate.js/3.2.1/translate.js"></script>
<script>
import {clickAdvert, configData} from '@/api/index'
import '@/assets/css/warper.less'
// 配置不需要显示右侧悬浮广告界面路径
const whiteList = ['/404', '/login', '/register', '/findPassword', '/feedback',
  '/bindPage', '/bindPhone', '/newInAutumn', '/draw', '/newEvent'];

export default {
  data() {
    return {
      rightAdList: [],
      leftAdList: [],
      isShow: false,
      seen:false,
      isEnglish:false
    }
  },
  created() {
    this.$store.dispatch('MallLogo')
    this.$store.dispatch('MallName')
    this.$store.dispatch('isRegister')
    this.$store.dispatch('MallIcp')
    this.$store.dispatch('CompanyName')
    this.$store.dispatch('MallKeywords')
    this.$store.dispatch('StatisticsCode')
    this.$store.dispatch('MallDesc')
    this.$store.dispatch('MallTitle')
    if (document.querySelector('meta[name="keywords"]')) {
      document.querySelector('meta[name="keywords"]').setAttribute('content', this.$store.state.mallKeywords)
    }
    if (document.querySelector('meta[name="description"]')) {
      document.querySelector('meta[name="description"]').setAttribute('content', this.$store.state.mallDesc)
    }


  },
  mounted() {
    // =================
    const script = document.createElement('script')
    script.src = 'https://s13.cnzz.com/z_stat.php?id=1274041432&web_id=1274041432'
    script.language = 'JavaScript'
    document.body.appendChild(script)

    // =================
    this.init()
    this.getAdList()
    //this.translateIn()
    window.onresize = () => {
      return (() => {
        this.init()
        //this.translateIn()
      })()
    }

  },
  methods: {
    init() {
      const windowWidth = document.documentElement.clientWidth || document.body.clientWidth
      if (windowWidth > 1400 && whiteList.indexOf(this.$route.path) == -1) {
        this.isShow = true
      } else {
        this.isShow = false
      }
      this.resetService()
      //translate.language.setLocal('chinese_simplified'); //设置本地语种（当前网页的语种）。如果不设置，默认就是 'chinese_simplified' 简体中文。 可填写如 'english'、'chinese_simplified' 等，具体参见文档下方关于此的说明
      /*translate.language.setUrlParamControl('lang');*/

    },
    goPage (page) {
      // 前往页面

      window.open(this.DOMAIN_URL + page)
    },
    translateIn(){
      translate.service.use('client.edge');
      //let lang = translate.language.getCurrent();
      translate.language.setUrlParamControl('lang');
     /* if(this.$route.query.lang !== 'undefined' && this.$route.query.lang == 'english'){
        if(lang != this.$route.query.lang){
          console.log("2english=")
          translate.language.setLocal('english');

          /!*translate.changeLanguage('english');*!/
        }else{
          console.log("2english!")
          translate.changeLanguage('english');

        }
      }else{
        translate.language.setLocal('chinese_simplified');
      }*/
      translate.language.setDefaultTo('english');
      translate.selectLanguageTag.show = false;
      //translate.listener.start();    //开启html页面变化的监控，对变化部分会进行自动翻译。注意，这里变化区域，是指使用 translate.setDocuments(...) 设置的区域。如果未设置，那么为监控整个网页的变化
      translate.execute();
    },
   /* isEnglish(){
      let url = this.$route.query.lang;
      console.log("切换英文1",url)
      if(url.includes("english")){
        return true
      }
      return false
    },*/

    /*goQq () {

      window.open("https://wpa.qq.com/msgrd?v=3&amp;uin=848906161&amp;site=qq&amp;menu=yes","_blank")
    },*/
    enter() {

      this.seen = true;
    },
    leave() {
      const that = this;
      that.seen = false;
     /* setTimeout(function(){
        that.seen = false;
      },1000)*/


    },
    getAdList() {
      this.$store.dispatch('GetAdList', {
        adPositionTypes: '1003'
      }).then((res) => {
        this.rightAdList = res.data.list
        this.$nextTick(() => {
          if (document.getElementById('rightAdv')) {
            const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
            const advHeight = document.getElementById('rightAdv').clientHeight
            document.getElementById('rightAdv').style.top = (windowHeight - advHeight-160) / 2 + 'px'
          }
        })
      })
      this.$store.dispatch('GetAdList', {
        adPositionTypes: '1031'
      }).then((res) => {
        this.leftAdList = res.data.list
        this.$nextTick(() => {
          if (document.getElementById('leftAdv')) {
            const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
            const advHeight = document.getElementById('leftAdv').clientHeight
            document.getElementById('leftAdv').style.top = (windowHeight - advHeight-160) / 2 + 'px'
          }
        })
      })
    },
    clickAd(id) {
      clickAdvert({ adId: id })
    },

    resetService() {
      this.$nextTick(() => {
        if (document.getElementById('newBridge')) {
          document.getElementById('newBridge').style.display = this.isShow ? 'block' : 'none';
        }
      })
    }
  },
  watch: {
    $route: {
      handler(value) {
        if (window._czc) {
          let location = window.location
          let contentUrl = location.pathname + location.hash
          let refererUrl = '/'
          window._czc.push(['_trackPageview', contentUrl, refererUrl])
        }
        this.isShow = whiteList.indexOf(value.path) == -1
        /*console.log("路径地址",value)*/
        this.translateIn()
        this.resetService()
      },
      deep: true
    }
  }
}
</script>

<style lang="less">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #020202;
}
/*左侧广告*/
.left_ad {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  position: fixed;
  top: 300px;
  right: e("calc(50% + 610px)");
  img {
    width: 100px;
    height: 260px;
    // object-fit: contain;
  }
}
/*右侧广告*/
.right_ad {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  position: fixed;
  top: 300px;
  left: e("calc(50% + 610px)");
  img {
    width: 100px;
    height: 260px;
    // object-fit: contain;
  }
}
::-webkit-scrollbar {
  width: 20px;
  height: 1px;
}
.back-top {
  width: 48px;
  height: 40px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  text-align: center;
  border-radius: 5px;
}
</style>
